import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { PagedResponse, ResourceApiService } from '@spike/core';
import { AbstractPageComponent, BasePageComponent, NoResultComponent } from '@spike/scaffolds';
import { Paginator } from "primeng/paginator";
import { EquipmentRequestSidePanelComponent } from "../../panels/equipment-request-side-panel/equipment-request-side-panel";
import { EquipmentRequestsTableComponent } from "../../components/equipment-requests-table/equipment-requests-table";
import { EquipmentRequestFiltersFormComponent } from "../../forms/equipment-request-filters-form/equipment-request-filters-form";
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { EquipmentRequestWorkflow } from 'src/app/features/workflow/models/workflow-status.enum';
import { PaginationModel } from 'src/app/features/shared/models/pagination-model';
import { SortingModel } from 'src/app/features/shared/models/sorting.model';
import { VEquipmentRequest } from '../../models/vequipment-request.model';
import { EquipmentRequest } from '../../models/equipment-request.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-equipment-request-page',
  providers:[],
  imports: [BasePageComponent, Paginator, NoResultComponent, EquipmentRequestSidePanelComponent, EquipmentRequestsTableComponent, EquipmentRequestFiltersFormComponent],
  templateUrl: './equipment-request-page.html'
})
export class EquipmentRequestPageComponent extends AbstractPageComponent{
    // Inject
  private readonly resourceApi = inject(ResourceApiService);

  // Inputs
  readonly entityApi = EntityApiEnum.EQUIPMENT_REQUEST
  
  // Inputs
  readonly workflowState= EquipmentRequestWorkflow;
  
  //local state
  public pagination = signal<PaginationModel>({ rows: 25, currentPage: 0, first: 0, rowsPerPageOptions: [25, 50, 100] });
  public isDialogVisible= signal<boolean>(false);
  public selectedItem = signal<number|undefined>(undefined);

  
  public readonly searchFilter = signal<any>({});
  public readonly sorting = signal<SortingModel>({ orderByClause: 'position_expire_date', orderDirection: 'desc' });
  
  public resourceFilter = computed(()=>{
    const searchFilter = this.searchFilter()
    const pagination = this.pagination();
    const sorting = this.sorting();

    const filter = {...searchFilter}
    return { filter: filter,  likable: true, currentPage: pagination.currentPage, maxResultPerPage: pagination.rows, orderByClause: sorting.orderByClause, orderDirection: sorting.orderDirection };


  })


  //resource
  public readonly entityList = this.resourceApi.call<PagedResponse<VEquipmentRequest>>(signal(this.entityApi),signal('searchView'), this.resourceFilter); 

  public onPageChange(event: any): void {
      this.pagination.update(p => ({...p, rows: event.rows || p.rows, first: event.first || 0, currentPage: event.page || 0}));
    }
    
    public onSelect(item: EquipmentRequest): void {
      this.selectedItem.set(item?.requestId);
      this.isDialogVisible.set(true);
    }

    public onSave(): void{
      this.entityList.reload();
    }

  }